import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestResponse,HttpHelper } from 'src/app/common/index';
import { HttpClient } from '@angular/common/http';
import { ChatGroup } from '../models/chat.model';
import { User, UserAuth } from 'src/app/common/user-auth';
import { pluck } from 'src/app/common/utilities';

@Injectable()
export class ChatService {
userAuth: User = UserAuth.get();
  constructor(public httpHelper: HttpHelper,
              private http: HttpClient) {

  }



  newConversation(user, conId):Observable<string> {
    const params = {id: conId, chatName:"",chatType:'personal',userIds:[this.userAuth.id.toString(),user?.id.toString()]};
    return this.httpHelper.postRequest(`/chats/newConversation`, params);
  }

  newConversationGroup(chatGroup: ChatGroup):Observable<any> {
    const params = {id:chatGroup.id,userIds:pluck([...chatGroup.users, this.userAuth], ['id']),users:chatGroup.membersDetails,chatName:chatGroup.chatName,chatType:"group"};
    return this.httpHelper.postRequest(`/chats/newConversation`, params);
  }

  newMessage(params):Observable<any> {
    return this.httpHelper.postRequest(`/chats/newMessage`, params);
  }

  getConversations(userId):Observable<any>{
    return this.httpHelper.getRequest(`/chats/conversation/${userId}`)
  }
  getChatMessage(chatId,pageNr):Observable<any>{
    return this.httpHelper.getRequest(`/chats/getChatMessage/${chatId}?pageNr=${pageNr}`);
  }
  clearMessages(chatId):Observable<any>{
    return this.httpHelper.getRequest(`/chats/clearMessages/${chatId}`);
  }
  updateUserStatus(user):Observable<any>{
    return this.httpHelper.postRequest(`/chats/updateUserStatus`,user);
  }
  broadcastTyping(typing, chatId) {
    return this.httpHelper.postRequest('/chats/typing', { typing, chatId });
  }
  unSendMessage(id: number):Observable<any>{
    return this.httpHelper.deleteRequest(`/chats/message/${id}`);
  }
  searcheMessages(text:string, conversationId: number):Observable<any>{
    return this.httpHelper.getRequest(`/chats/search/messages?text=${text}&conversationId=${conversationId}`);
  }
  getMessagesUntilId(id:string, conversationId: number):Observable<any>{
    return this.httpHelper.getRequest(`/chats/messagesUntilId?id=${id}&conversationId=${conversationId}`);
  }
  getCountUnSeenMessages():Observable<any>{
    return this.httpHelper.getRequest(`/chats/countUnSeenMessages`);
  }
  broadcastSeenMessages(messages=[],userId):Observable<any>{
    return this.httpHelper.postRequest(`/chats/broadcastSeenMessage`, {messages, userId});
  }
  getEmployeesForExtern(): Observable<any> {
    return this.httpHelper.getRequest('/chats/getEmployeesForExtern');
  }
  getDeletedConversations() {
    return this.httpHelper.getRequest('/chats/deletedConversations');
  }
  deletConversation(id) {
    return this.httpHelper.deleteRequest(`/chats/conversation/${id}`);
  }
}
